import { Box, Theme } from "@mui/material";
import { HEADER_HEIGHT } from "@knowfully/ui.common";
import { ReactNode } from "react";

const styles = {
  grid: {
    display: "grid",
    gap: 3,
    gridTemplateColumns: {
      xs: "minmax(0, 1fr)",
      lg: "minmax(0, 2.5fr) minmax(280px, 1fr)",
    },
    alignItems: "start",
  },
  main: {
    order: { xs: 2, lg: 1 },
  },
  sidebar: {
    order: { xs: 1, lg: 2 },
    position: { lg: "sticky" },
    top: (theme: Theme) => `calc(${HEADER_HEIGHT} + ${theme.spacing(3)})`,
  },
};

type SkuPageLayoutProps = {
  children: ReactNode;
  sidebar: ReactNode;
};

/**
 * Lays the SKU page out as content plus a summary sidebar that stays in view while the page scrolls.
 * Below `lg` the sidebar moves above the content instead; the order is swapped in CSS so the sidebar
 * is never remounted, which would drop anything portalled into it.
 */
const SkuPageLayout = ({ children, sidebar }: SkuPageLayoutProps) => {
  return (
    <Box sx={styles.grid}>
      <Box sx={styles.main}>{children}</Box>
      <Box component="aside" sx={styles.sidebar}>
        {sidebar}
      </Box>
    </Box>
  );
};

export default SkuPageLayout;
